export enum ActionTypes {
  CREATE_REPORT_TARGET_REQUEST = '@@report_summary/CREATE_REPORT_TARGET_REQUEST',
  CREATE_REPORT_TARGET_SUCCESS = '@@report_summary/CREATE_REPORT_TARGET_SUCCESS',
  CREATE_REPORT_TARGET_FAILURE = '@@report_summary/CREATE_REPORT_TARGET_FAILURE',
}
